// src/components/IconNav.js
import React from "react";
import favicon from "../assets/favicon.png";
import "./IconNav.css"; // you can remove the width rule, or scope it to a default

export default function IconNav({ onClick, size = 32 }) {
  return (
    <div className="icon-nav">
      <img
        src={favicon}
        alt="App Icon"
        onClick={onClick}
        style={{
          width: `${size}px`,
          height: "auto",
          cursor: "pointer",
        }}
      />
    </div>
  );
}
